import * as Yup from "yup";

/* eslint-disable no-useless-escape */
const ForgotPasswordValidation = (t) => {
  return Yup.object().shape({
    password: Yup.string()
      .min(8)
      .required()
      .matches(/\p{Ll}/u)
      .matches(/[A-Z]/)
      .matches(/[0-9]/)
      .matches(/[\^$*.{}\[\]()?"!@#%&/\\,><':;|_~`=+\-]/),
    passwordConfirm: Yup.string().oneOf(
      [Yup.ref("password")],
      t("forgotPassword.passwordError")
    ),
  });
};

export default ForgotPasswordValidation;
